import { routeUrl } from '@actions/route-guard.actions';
import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { map } from 'rxjs/operators';

import { State } from '../reducers';
import { CurrentUserService } from './current-user.service';

@Injectable()
export class RequireConfirmedContactMethodsGuard {
  user$ = this.currentUserService.user$;

  constructor(
    private currentUserService: CurrentUserService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private router: Router,
    private store: Store<State>
  ) {}

  canActivate(routerSnapshot: RouterStateSnapshot) {
    return this.currentUserService.user$.pipe(
      map((user) => {
        const userIsBeingImpersonated = user.impersonatedBy !== null;
        const allContactMethodsConfirmed = user.contactMethods.every((cm) => cm.confirmed);

        if (userIsBeingImpersonated || allContactMethodsConfirmed) {
          this.store.dispatch(routeUrl({ routeUrl: null }));
          return true;
        }

        this.messageService.add({
          severity: 'warn',
          summary: this.translateService.instant('require-confirmed-contact-methods-guard.please-confirm')
        });

        this.store.dispatch(routeUrl({ routeUrl: routerSnapshot.url }));
        this.router.navigate(['/user']);
        return false;
      })
    );
  }
}
